import {
    Beat,
    Checkout,
    generateRouteFromPage,
    Order,
    Service,
    Search,
    Song,
    SoundKit,
    Orders,
    OrderDetails,
    BeatTapes,
    BeatTape,
    Quotation,
} from '../components/routes'
import Vue from "vue/dist/vue.js";
import Router from "vue-router";
import store from "../store/store";

Vue.use(Router);

export default (function createRouter() {
    const routes = [];

    // Push routes from generated config pages routes
    ab.config.pagesConfig.forEach((page) => {
        const route = generateRouteFromPage(page);
        routes.push(route);
    });

    // Push routes from generic pages
    routes.push(
        {
            path: '/beats/:beat',
            component: Beat,
            name: 'beat'
        },
        {
            path: '/soundkits/:soundkit',
            component: SoundKit,
            name: 'soundkit'
        },
        {
            path: '/songs/:song',
            component: Song,
            name: 'song'
        },
        {
            path: '/services/:service',
            component: Service,
            name: 'service'
        },
        {
            path: '/checkout',
            component: Checkout,
            name: 'checkout'
        },
        {
            path: '/order/:number/:code',
            component: Order,
            name: 'order'
        },
        {
            path: '/quotation/:number',
            component: Quotation,
            name: 'quotation'
        },
        {
            path: '/search',
            component: Search,
            name: 'search',
            meta: {
                pageName: 'Search'
            }
        },
        {
            path: '*',
            redirect: '/'
        },
        {
            path: '/orders/history',
            component: Orders,
            name: 'order-history'
        },
        {
            path: '/orders/:orderId',
            component: OrderDetails,
            name: 'order-details'
        },
        {
            path: '/beat-tapes/:beatTape',
            component: BeatTape,
            name: 'beat-tape',
            props: route => ({ pageId: route.params.pageId })
        },
        {
            path: 'beat-tapes',
            component: BeatTapes,
            name: 'beat-tapes'
        },
    );

    // Init router
    const router = new Router({
        mode: 'history',
        routes,
        scrollBehavior(to, from, savedPosition) {
            $('#content').css('height', '100%');
            setTimeout(() => {
                $('#content').css('height', '100vh')
            }, 10);

            if (savedPosition) {
                return savedPosition;
            } else if (to.hash) {
                return {anchor: true};
            } else if (to.meta.scroll !== undefined && !to.meta.scroll) {
                return false;
            } else {
                return {x: 0, y: 0};
            }
        },
    });

    // Before Each hook
    router.beforeEach((to, from, next) => {
        let redirect = false;

        if (from.query.config_id !== undefined && to.query.config_id === undefined) {
            to.query.config_id = from.query.config_id;
            redirect = true;
        }
        if (from.query.edit !== undefined && to.query.edit === undefined) {
            to.query.edit = from.query.edit;
            redirect = true;
        }

        let homePath = (store.state.currentConfig) ? store.state.currentConfig.homePage.link : '/';
        let route = (from.path !== homePath) ? from : null;
        store.commit("previousRoute", {route: route});
        store.commit("singleMusicPageName", {name: null});

        if (redirect) {
            next({name: to.name, path: to.path, query: to.query, params: to.params});
        } else {
            next();
        }
    });

    return router;
})();

